<template>
    <div>
        <input type="hidden" :value="JSON.stringify(services)" name="invoice_items">

        <div v-if="loading">
            <div class="text-center">
                <span style="font-size: 22px"><i class="fa fa-refresh fa-spin"></i></span>
            </div>
        </div>
        <div v-else>
            <div style="margin-bottom: 5px;" v-if="items.length>0">
                <button type="button" v-if="!readOnly" class="btn btn-block purple" @click="addService('prepend')"><i class="fa fa-plus"></i> Ajouter un service</button>
            </div>
            <div v-for="(item, index) in items" v-bind:key="index">
                <div v-if="item.type == 'service'" class="service-item" style="position: relative; margin-bottom: 10px;">
                    
                    <div style="display: flex">
                        <div style="flex-grow: 1">
                            <div style="padding: 0 5px 5px 0;">Service</div>

                            <select-two-items 
                                style="width: 100%;"
                                :id="'select2-item-service-'+item.service_index" 
                                dropdown-parent="#form_invoice" 
                                :endpoint="itemEndpoint" 
                                :type="item.type" 
                                v-model="item.invoice_detail_item" 
                                @selected="onSelect(item.service_index, item.part_index, $event)" 
                                @clear="onClear(item.service_index, item.part_index)" 
                                :ref="'select2-item-service-'+item.service_index" 
                                :initial-value="(item.invoice_detail_item.id)?item.invoice_detail_item.id.toString():''"  
                                :initial-display="item.invoice_detail_item.text"
                                :add-form-base-end-point="baseEndpoint+'service/add'"
                                :add-form-title="'Ajout d\'un service'"
                                :add-form-selector="'#form_service'"
                                :add-text-input-selector="'#service_name'"
                                :edit-form-base-end-point="baseEndpoint+'service/edit'"
                                :edit-form-title="'Modifier un service'"
                                :edit-form-selector="'#form_service'"
                                :edit-text-input-selector="'#service_name'"
                                :allow-add="allowAddServices"
                                :allow-edit="allowEditServices"
                            ></select-two-items>
                            
                            <div style="margin-top: 5px">
                                <div style="display: flex">
                                    <div style="flex-grow: 1">
                                        <div>Description:</div>
                                        <div style="margin-top: 5px;">
                                            <textarea class="form-control" style="width:100%; height: 100px; min-height: 35px; resize: vertical;" v-model="item.invoice_detail_description"></textarea>
                                        </div>
                                    </div>
                                    <div style="margin-left: 5px; width: 170px">
                                        <div>Quantité:</div>
                                        <div style="margin-top: 5px;">
                                            <input style="width: 100%;" class="form-control invoice_detail_qty" type="number" v-model="item.invoice_detail_qty">
                                        </div>
                                        <template v-if="!isSoumission">
                                        <div class="text-left invoice_detail_parts_status_div">
                                            <input class="invoice_detail_parts_status" type="checkbox" :checked="item.invoice_detail_parts_status == 1" @change="checkboxOrderStatusChange(item, 1, $event)"> 
                                            <label @click="checkboxOrderStatusChange(item, 1, $event)">Pièces à commander</label>
                                        </div>
                                        <div class="text-left invoice_detail_parts_status_div">
                                            <input class="invoice_detail_parts_status" type="checkbox" :checked="item.invoice_detail_parts_status == 2" @change="checkboxOrderStatusChange(item, 2, $event)"> 
                                            <label @click="checkboxOrderStatusChange(item, 2, $event)">Pièces commandées</label>
                                        </div>
                                        <div class="text-left invoice_detail_parts_status_div">
                                            <input class="invoice_detail_parts_status" type="checkbox" :checked="item.invoice_detail_parts_status == 3" @change="checkboxOrderStatusChange(item, 3, $event)"> 
                                            <label @click="checkboxOrderStatusChange(item, 3, $event)">Pièces reçues</label>
                                        </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-left: 5px;">
                            <a class="btn btn-circle btn-icon-only btn-default tooltips" @click="removeItem(item.service_index, item.part_index)" data-container="body" data-placement="top" data-original-title='Supprimer' href="javascript:;" title="Supprimer">
                                <i class="icon-trash"></i>
                            </a>
                        </div>
                    </div>

                    <div v-for="(part, index2) in item.parts" v-bind:key="index2" class="part-item" style="margin-right: 40px">
                        <div style="display: flex">
                            <div style="flex-grow: 1">
                                <div style="padding: 0 5px 5px 0;">Pièce</div>
                                <select-two-items style="width: 100%;" :id="'select2-item-part-'+index+'-'+index2" :endpoint="itemEndpoint" :type="part.type" v-model="part.invoice_detail_item" @selected="onSelect(part.service_index, part.part_index, $event)" @clear="onClear(part.service_index, part.part_index)" :ref="'select2-item-part-'+part.service_index+'-'+part.part_index" :initial-value="part.invoice_detail_item.id" :initial-display="part.invoice_detail_item.text" :add-form-base-end-point="baseEndpoint+'part/add'" :add-form-title="'Ajout d\'une pièce'" :add-form-selector="'#form_part'" :add-text-input-selector="'#part_name'" :edit-form-base-end-point="baseEndpoint+'part/edit'" :edit-form-title="'Modifier une pièce'" :edit-form-selector="'#form_part'" :edit-text-input-selector="'#part_name'" :allow-add="allowAddParts" :allow-edit="allowEditParts" :allow-quick-add="allowAddParts"></select-two-items>
                                <div style="margin-top: 5px">
                                    <div style="display: flex">
                                        <div style="flex-grow: 1">
                                            <div>Description:</div>
                                            <div style="margin-top: 5px;">
                                                <textarea class="form-control" style="width:100%; height: 50px; min-height: 35px; resize: vertical;" v-model="part.invoice_detail_description"></textarea>
                                            </div>
                                        </div>
                                        <div style="margin-left: 5px; width: 170px">
                                            <div>Quantité:</div>
                                            <div style="margin-top: 5px;">
                                                <input style="width: 100%;" class="form-control invoice_detail_qty" type="number" v-model="part.invoice_detail_qty">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-left: 5px;">
                                <a class="btn btn-circle btn-icon-only btn-default tooltips" @click="removeItem(part.service_index, part.part_index)" data-container="body" data-placement="top" data-original-title='Supprimer' href="javascript:;" title="Supprimer">
                                    <i class="icon-trash"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 5px; margin-right: 40px">
                        <button type="button" v-if="!readOnly" class="btn btn-block btn-sm secondary" @click="addPart(item.service_index)"><i class="fa fa-plus"></i> Ajouter une pièce</button>
                    </div>
                </div>
            </div>
            <div style="margin-top: 5px;">
                <button type="button" v-if="!readOnly" class="btn btn-block purple" @click="addService('append')"><i class="fa fa-plus"></i> Ajouter un service</button>
            </div>
        </div>

    </div>
</template>

<script>
module.exports = {
    name: "invoice-detail-list-form",
    props: {
        invoiceId: {
            type: String,
            required: true
        },
        baseEndpoint: {
            type: String,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        isSoumission: {
            type: Boolean,
            default: false
        },
        allowEditServices: {
            type: Boolean,
            default: true
        },
        allowAddServices: {
            type: Boolean,
            default: true
        },
        allowEditParts: {
            type: Boolean,
            default: true
        },
        allowAddParts: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            services: [],
            oldItems: [],
            loading: true,
            items: [],
            allItems: [],
            allExpanded: false,
            value: ""
        }
    },
    watch: {
        items: {
            handler(){
                window.toggleWarn(true);
            },
            deep: true
        }
    },
    mounted(){
        this.loadItems();
    },
    computed:{
        itemEndpoint: function(){
            return this.baseEndpoint + "invoice/select2/allitems";
        },
    },
    methods:{
        loadItems: function(){
            var that = this;
            this.loading = true;

            if(parseInt(this.invoiceId) == 0){
                that.loading = false;
                that.recomputeItems();
                return;
            }

            $.get(this.baseEndpoint + "invoice/view/"+this.invoiceId+"/details", function(data){
                that.services = data;
                that.loading = false;

                data.forEach(function(res){
                    res.type = "service";
                    res.invoice_detail_taxable_tps = res.invoice_detail_taxable_tps == "1";
                    res.invoice_detail_taxable_tvq = res.invoice_detail_taxable_tvq == "1";
                    res.invoice_detail_parts_status = parseInt(res.invoice_detail_parts_status);
                    res.expanded = true;
                    
                    if(res.invoice_detail_service_id != 0){
                        res.invoice_detail_item = {
                            id: "service-"+res.invoice_detail_service_id,
                            item_id: res.invoice_detail_service_id,
                            text: res.service_name,
                            type: "service"
                        };
                    }
                    else{
                        res.invoice_detail_item = {
                            id: null,
                            item_id: null,
                            text: "",
                            type: null
                        };
                    }

                    var part_index = 0;
                    res.parts.forEach(function(part){
                        
                        part.type = "part";
                        part.invoice_detail_taxable_tps = part.invoice_detail_taxable_tps == "1";
                        part.invoice_detail_taxable_tvq = part.invoice_detail_taxable_tvq == "1";
                        part.invoice_detail_selected = part.invoice_detail_selected == null || part.invoice_detail_selected == "1" || part.invoice_detail_selected === true;
                        part.invoice_detail_parts_status = 0;

                        if(part.invoice_detail_part_id != 0){
                            part.invoice_detail_item = {
                                text: that.formatPartDisplay(part),
                                item_id: part.invoice_detail_part_id,
                                id: "part-"+part.invoice_detail_part_id,
                                type: "part"
                            };
                        }
                        else{
                            part.invoice_detail_item = {
                                id: null,
                                item_id: null,
                                text: "",
                                type: null
                            };
                        }
                    });
                })
                
                that.recomputeItems();
                that.oldItems = JSON.parse(JSON.stringify(that.services));

                setTimeout(function(){
                    window.toggleWarn(false);
                }, 100);

            }, "json")
        },
        round: function(number, precision){
            number += 0.00000001;
            return number.toFixed(2);
        },
        formatPartDisplay: function(part){
            var name = part.part_name || part.name || part.part_number || '';
            var supplier = part.supplier_name || '—';
            var inventory = Math.round(parseFloat(part.part_inventory || 0) * 100) / 100;
            return name + ' - ' + supplier + ' - QTÉ [' + inventory + ']';
        },
        getNbPartsOfService: function(service_index){
            return this.services[service_index].parts.length;
        },
        removeEmptyLines: function(){
            for(var svc_ix in this.services){
                this.services[svc_ix].parts = this.services[svc_ix].parts.filter(function(part){
                    return part.invoice_detail_part_id != null;
                })
            }

            this.services = this.services.filter(function(service){
                return service.parts.length != 0 || service.invoice_detail_service_id != null;
            })
        },
        recomputeItems: function(){
            var allItems = [];
            var items = [];
            var service_index = 0;
            this.services.forEach(function(service){
                service.service_index = service_index
                items.push(service);
                allItems.push(service);
                if(service.parts !== undefined){
                    var part_index = 0;
                    service.parts.forEach(function(part){
                        part.part_index = part_index;
                        part.service_index = service_index
                        if(service.expanded){
                            items.push(part);
                        }
                        allItems.push(part);
                        part_index++;
                    })
                }
                service_index++;
            });
            this.items = items;
            this.allItems = allItems;
        },
        toggleExpand: function(service_index){
            this.services[service_index].expanded = !this.services[service_index].expanded;

            var isExpandAll = false;
            this.services.forEach(function(service){
                if(!isExpandAll && service.expanded){
                    isExpandAll = true;
                }
            });
            
            this.allExpanded = isExpandAll;

            this.recomputeItems();
            this.$forceUpdate();
        },
        toggleExpandAll: function(){
            var that = this;
            this.allExpanded = !this.allExpanded;
            this.services.forEach(function(service){
                service.expanded = that.allExpanded;
            });
            this.recomputeItems();
            this.$forceUpdate();
        },
        addService: function(appendPrepend){
            var that = this;
            var index = this.services.length; // Index service

            this.services.push({
                type: "service",
                invoice_detail_id: null,
                invoice_detail_item: {id:null, text:"", type:null},
                invoice_detail_part_id: null,
                invoice_detail_service_id: null,
                invoice_detail_invoice_id: that.invoiceId,
                invoice_detail_description: "",
                invoice_detail_qty: "1.00",
                invoice_detail_selected: true,
                invoice_detail_parts_status: 1,
                service_index: index,
                expanded: false,
                parts: []
            })

            this.recomputeItems();

            setTimeout(function(){
                that.$refs["select2-item-service-"+index][0].openFocus = true;
                $(".modal-body").last().scrollTop(5000)
            }, 50)
        },
        removeItem: function(service_index, part_index){
            let _this = this;
            bootbox.dialog({
                title: "Supprimer un item",
                message: "Êtes-vous sûr de supprimer cet item?",
                buttons: {				
                    remove: {
                        label: L('YES_WORD'),
                        className: "btn-danger",
                        callback: function() {
                            if(part_index === undefined){
                                _this.services.splice(service_index, 1);
                            }
                            else{
                                var service = _this.services[service_index];
                                service.parts.splice(part_index, 1);
                            }
                            _this.recomputeItems();
                        }
                    },					
                    cancel: {
                        label: L("CANCEL"),
                        className: "btn",
                        callback: function() {

                        }
                    }
                }
            })
        },
        addPart: function(ix){
            var that = this;
            var service = this.services[ix];
            var index = service.parts.length;
            service.parts.push({
                type: "part",
                invoice_detail_id: null,
                invoice_detail_item: { id: null, text: "", type: null },
                invoice_detail_part_id: null,
                invoice_detail_service_id: null,
                invoice_detail_invoice_id: that.invoiceId,
                invoice_detail_description: "",
                invoice_detail_qty: "1.00",
                service_index: ix,
                part_index: index
            })
            service.expanded = true;
            this.recomputeItems();

            setTimeout(function(){
                that.$refs["select2-item-part-"+ix+"-"+index][0].openFocus = true;
                //this.$refs["select2-part-"+index][this.$refs["select2-part-"+index].length-1].addItem();
            }, 50)
        },
        onSelect: function(service_index, part_index, item){
            var split = item.id.toString().split("-");
            var id = split[1];
            var type = split[0];

            if(part_index === undefined) { // Service
                this.services[service_index].invoice_detail_part_id = null;
                this.services[service_index].invoice_detail_service_id = id;
                this.services[service_index].invoice_detail_description = item.description;
                this.services[service_index].invoice_detail_hours = item.service_quantity_fixed;
                this.services[service_index].invoice_detail_hour_rate = item.service_quantity_per_hour;
            }
            else { // Pièce
                this.services[service_index].parts[part_index].invoice_detail_part_id = id;
                this.services[service_index].parts[part_index].invoice_detail_service_id = null;
                this.services[service_index].parts[part_index].invoice_detail_description = item.description;
            }

            this.$forceUpdate();
        },
        onClear: function(service_index, part_index){
            if(part_index === undefined) { // Service
                this.services[service_index].invoice_detail_part_id = null;
                this.services[service_index].invoice_detail_service_id = null;
            }
            else { // Pièce
                this.services[service_index].parts[part_index].invoice_detail_part_id = null;
                this.services[service_index].parts[part_index].invoice_detail_service_id = null;
            }
            this.$forceUpdate();
        },
        cancelChanges: function(){
            this.services = JSON.parse(JSON.stringify(this.oldItems));
            this.recomputeItems();
        },
        checkboxOrderStatusChange(item, value, event){
            item.invoice_detail_parts_status = (item.invoice_detail_parts_status == value) ? 0 : value;
        }
    }
}
</script>

<style lang="scss">

    .service-item{
        border: 1px solid #aaa;
        border-radius: 5px;
        box-shadow: 0 0 4px #777;
        padding: 5px;
    }

    .part-item{
        border: 1px solid #aaa;
        border-radius: 3px;
        box-shadow: 0 0 4px #777;
        padding: 5px;
        margin-top: 5px;
        background-color: rgb(214, 226, 231);
    }

    .invoice_detail_parts_status_div{
        vertical-align: top;
    }

    input.invoice_detail_parts_status{
        width: 14px;
        height: 14px;
        margin-top: 0;
        vertical-align: middle;
    }

    .select2 {
        width:100% !important;
    }
</style>
